exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.clientAvatar {\n  margin-right: 5px;\n  vertical-align: top;\n}\n.clientContainer {\n  margin-bottom: 5px;\n}\n.clientDetailsRow {\n  margin-bottom: 10px;\n}\n.clientStatusAndImage {\n  margin-right: 15px;\n}\n.stayCard {\n  background-color: #ffffff;\n  min-width: 800px;\n}\n.staySelector {\n  width: 280px;\n}\n", ""]);

// exports
